import { Component, OnInit } from '@angular/core';
import DDIOptions from 'src/app/data/ddi';
import { ApiService } from 'src/app/services/api/api.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-dashboard-permissions-list-details',
  templateUrl: './dashboard-permissions-list-details.component.html',
  styleUrls: ['./dashboard-permissions-list-details.component.scss'],
})
export class DashboardPermissionsListDetailsComponent implements OnInit {
  permissionObj = {
    canChange: true,
    canInactive: true,
  };

  DDIOptions = DDIOptions;

  loading = true;

  data: PermissionDetailsValue;
  permissionsArray: GroupPermission[] = [];

  permissionTree: any[] = [];
  permissionsAvaliablePicked = [];
  permissionsBaseData = [];

  // Propriedades para o warning modal
  showStatusModal = false;
  isActive: boolean = false;

  constructor(
    private api: ApiService,
    private toast: ToastService,
    public signupService: SignupService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.authService.canViewPage(['de_can_view_permissions']);

    this.setBreadcrumb();
    this.setPermissions();
    this.getData();
  }

  async getData() {
    try {
      const id = this.route.snapshot.params.id;
      const res = await this.api.get({
        route: `api/v2/group/${id}/`,
        token: true,
      });

      this.data = res;

      this.permissionTree = this.buildPermissionTree(this.data.permissions);
      this.formatList(this.data.permissions);
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.loading = false;
  }

  addPermission() {
    this.router.navigateByUrl(
      `/app/permissions/update/${this.route.snapshot.params.id}`
    );
  }

  formatList(list: EachPermission[]) {
    let arr: GroupPermission[] = [];

    list.forEach((item) => {
      const finded = arr.find((el) => el.type === item.type);

      if (finded) {
        finded.permissions.push(item);
      } else {
        arr.push({
          type: item.type,
          permissions: [item],
        });
      }
    });

    this.permissionsArray = arr;
  }

  togglePermissionStatus() {
    this.isActive = this.data.status === 'Ativo';
    this.showStatusModal = true;
  }

  async confirmStatusChange() {
    try {
      await this.api.patch({
        route: `api/v2/group/${this.data.id}/`,
        token: true,
        body: { status: !this.isActive, name: this.data.group },
      });

      this.loading = true;
      this.showStatusModal = false;
      this.getData();

      this.toast.show(
        'info',
        'Sucesso',
        `Permissão ${this.isActive ? 'inativada' : 'ativada'} com sucesso.`
      );
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        `Ocorreu um erro ao alterar status da permissão.`
      );
    }
  }

  closeStatusModal() {
    this.showStatusModal = false;
    this.isActive = false;
  }

  getModalTitle(): string {
    return this.isActive
      ? 'Inativar grupo de permissão'
      : 'Ativar grupo de permissão';
  }

  getModalMessage(): string {
    return `Deseja ${
      this.isActive ? 'inativar' : 'ativar'
    } esse grupo de permissão? Todos os perfis de usuário vinculados a ela serão afetados nessa operação.`;
  }

  getConfirmText(): string {
    return `Sim, ${this.isActive ? 'inativar' : 'ativar'} grupo de permissões`;
  }

  setPermissions() {
    const permissions = Object.keys(this.permissionObj).map(
      (key) => `de_can_${key.split('can').join('').toLowerCase()}_permissions`
    );

    permissions.forEach((permission, idx) => {
      this.permissionObj[Object.keys(this.permissionObj)[idx]] =
        this.authService.verifyPermission(permission);
    });
  }

  buildPermissionTree(flatList: any[], availableIds: number[] = []): any[] {
    const lookup: Record<number, any> = {};
    const tree: any[] = [];

    flatList.forEach((item) => {
      lookup[item.id] = { ...item, children: [] };
    });

    flatList.forEach((item) => {
      const parent = item.parent_permission;
      if (parent && lookup[parent.id]) {
        lookup[parent.id].children.push(lookup[item.id]);
      } else {
        tree.push(lookup[item.id]);
      }
    });

    const pruneTree = (nodes: any[]): any[] => {
      return nodes
        .map((node) => {
          const prunedChildren = pruneTree(node.children || []);
          const isInOriginal = flatList.some((item) => item.id === node.id);
          if (prunedChildren.length > 0 || isInOriginal) {
            return {
              ...node,
              children: prunedChildren,
            };
          }
          return null;
        })
        .filter((node) => node !== null);
    };

    return pruneTree(tree);
  }

  handlePermissionSelection(event) {}

  setBreadcrumb(): void {
    const canViewPermissions = this.authService.verifyPermission(
      'de_can_view_permissions'
    );
    const canViewList = this.authService.verifyPermission(
      'de_can_view_permissions'
    );
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Permissões',
        url: '/app/permissions',
        clickable: canViewPermissions,
      },
      {
        label: 'Controle de permissões',
        url: '/app/permissions/list',
        clickable: canViewList,
      },
      {
        label: 'Detalhes do grupo de permissão',
        url: this.router.url,
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }
}
